export default __webpack_public_path__ + "static/media/graphite_monitor.08efcac8.md";